module.exports = __webpack_public_path__ + "assets/logo_project_management.89c8b807.svg";